export const INITIAL_STATE = {
  Name: "",
  Email: "",
  ContactNumber: "",
  ProjectDetail: "Request a consultation",
  ProjectBrief: "",
  Experience: "",
};

export const formReducer = (state, action) => {
  switch (action.type) {
    case "CHANGE_INPUT":
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    default:
      return state;
  }
};
